import {Injectable} from '@angular/core';
import {GenericService} from "../../../core/commons/generic.service";
import {Post} from "../../domain/post";
import {AuthService} from "../../../core/security/auth.service";
import {QueryOptions} from "../../../core/commons/query.options";
import {Observable} from "rxjs/Observable";
import {RequestMethod} from "@angular/http";
import {Topic} from "../../domain/topic";

@Injectable()
export class PostService extends GenericService<Post> {

    private resourcePath: string = "/post";

    constructor(public authService: AuthService) {
        super(authService);
    }

    protected valueToEntity(value: Object): Post {
        return new Post(value);
    }

    protected getResourcePath(): string {
        return this.resourcePath;
    }

    public getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public addLike(id: number): Observable<Post> {
        let req = this.buildRequest(RequestMethod.Post, JSON.stringify(id));
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + "/add_like", req)
            .map(res => this.valueToEntity(res.json()));
    }

    public findByTopic(topic : Topic): Observable<Post[]> {
        let req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + "/by_topic/"+ topic.id, req)
            .map(res => res.json().map(t => this.valueToEntity(t)));
    }

    public findLastPosts(): Observable<Post[]> {
        let req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + "/last_posts", req)
            .map(res => res.json().map(t => this.valueToEntity(t)));
    }

    public changePostState( p : Post ): Observable<Post> {
        let req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + "/change_state/"+ p.id, req)
            .map(res => this.valueToEntity( res.json() ));
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/forum/post.service.ts